export const iconFontAwesomeShoppingCertificate = (
	<i className="fa-solid fa-certificate"></i>
);
